// src/services/UnivapayService.js - UnivaPay本番統合版
import { app } from '../firebase';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';

const db = getFirestore(app);

class UnivapayService {
  constructor() {
    this.appToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcHBfdG9rZW4iLCJpYXQiOjE3NzQ2MDExNDIsIm1lcmNoYW50X2lkIjoiMTFlZjQ4NDMtOThkYS0wNmU2LWFiZmUtN2YyZTYwYzEzZjkzIiwic3RvcmVfaWQiOiIxMWVmNDg0My05OWFiLTNiOWUtYWMwMi1kMzQwYjFhODEwMWUiLCJkb21haW5zIjpbInd3dy5ub2Jpc2hpcm8tY29tcGV0ZW5jeS5jb20iXSwibW9kZSI6ImxpdmUiLCJjcmVhdG9yX2lkIjoiMTFlZjQ4NDMtOThkYS0wNmU2LWFiZmUtN2YyZTYwYzEzZjkzIiwidmVyc2lvbiI6MSwianRpIjoiMTFmMTI5YjktNTY2Yy00ZTQ2LWJlMmMtN2IzNmY0NGNlYmY0In0.F7zlx07vv1H103P1289U-_W9384BazybpYfUyrfECZg';
    this.pricingPlans = {
      free:     { id: 'free',     name: 'Freeプラン',     price: 0,    checkoutUrl: null },
      student:  { id: 'student',  name: 'Studentプラン',  price: 480,  checkoutUrl: 'https://univa.cc/z-hHrC' },
      standard: { id: 'standard', name: 'Standardプラン', price: 980,  checkoutUrl: 'https://univa.cc/su0h0x' },
      business: { id: 'business', name: 'Businessプラン', price: 4980, checkoutUrl: 'https://univa.cc/83Fppy' },
    };
  }

  // ホスト型決済ページへリダイレクト（UnivaPay本番）
  async createCheckoutSession(planId) {
    const plan = this.pricingPlans[planId];
    if (!plan) throw new Error('無効なプランです');
    if (plan.price === 0) throw new Error('Freeプランへの変更はできません');

    // UnivaPayのホスト型URLにユーザーIDをパラメータで渡す
    const { getAuth } = await import('firebase/auth');
    const user = getAuth().currentUser;
    if (!user) throw new Error('ログインが必要です');

    const redirectUrl = encodeURIComponent(`https://www.nobishiro-competency.com/payment-complete?plan=${plan.id}`);
    const checkoutUrl = `${plan.checkoutUrl}?uid=${user.uid}&email=${encodeURIComponent(user.email || '')}&redirect_url=${redirectUrl}`;
    return { success: true, checkoutUrl, planId: plan.id, isDemoMode: false };
  }

  // プラン情報取得
  getPlan(planId) {
    return this.pricingPlans[planId] || this.pricingPlans.free;
  }

  getAllPlans() {
    return Object.values(this.pricingPlans);
  }
}

const univapayService = new UnivapayService();
export default univapayService;
